export var ApprovalStatusEn;
(function (ApprovalStatusEn) {
    ApprovalStatusEn[ApprovalStatusEn["Waiting"] = 0] = "Waiting";
    ApprovalStatusEn[ApprovalStatusEn["Approve"] = 1] = "Approve";
    ApprovalStatusEn[ApprovalStatusEn["Reject"] = 2] = "Reject";
})(ApprovalStatusEn || (ApprovalStatusEn = {}));
export var TicketStatusEn;
(function (TicketStatusEn) {
    TicketStatusEn[TicketStatusEn["Open"] = 1] = "Open";
    TicketStatusEn[TicketStatusEn["Approved"] = 2] = "Approved";
    TicketStatusEn[TicketStatusEn["Handling"] = 4] = "Handling";
    TicketStatusEn[TicketStatusEn["HandleCompleted"] = 5] = "HandleCompleted";
    TicketStatusEn[TicketStatusEn["Finished"] = 6] = "Finished";
    TicketStatusEn[TicketStatusEn["Reject"] = 7] = "Reject";
    TicketStatusEn[TicketStatusEn["Canceled"] = 8] = "Canceled";
    TicketStatusEn[TicketStatusEn["Draft"] = 9] = "Draft";
})(TicketStatusEn || (TicketStatusEn = {}));
export const ticketStatusArr = [
    { value: TicketStatusEn.Open, label: 'Mới' },
    { value: TicketStatusEn.Approved, label: 'Đã phê duyệt' },
    { value: TicketStatusEn.Handling, label: 'Đang xử lý' },
    { value: TicketStatusEn.Finished, label: 'Đã hoàn thành' },
    { value: TicketStatusEn.Reject, label: 'Từ chối' },
    { value: TicketStatusEn.Canceled, label: 'Hủy' },
    { value: TicketStatusEn.Draft, label: 'Nháp' }
];
export var DisplayedApprovalOrderEn;
(function (DisplayedApprovalOrderEn) {
    DisplayedApprovalOrderEn[DisplayedApprovalOrderEn["Create"] = 1] = "Create";
    DisplayedApprovalOrderEn[DisplayedApprovalOrderEn["Approve"] = 2] = "Approve";
    DisplayedApprovalOrderEn[DisplayedApprovalOrderEn["Done"] = 3] = "Done";
})(DisplayedApprovalOrderEn || (DisplayedApprovalOrderEn = {}));
export var HrConfirmEn;
(function (HrConfirmEn) {
    HrConfirmEn[HrConfirmEn["Waiting"] = 0] = "Waiting";
    HrConfirmEn[HrConfirmEn["Confirmed"] = 1] = "Confirmed";
    HrConfirmEn[HrConfirmEn["Synchronized"] = 2] = "Synchronized";
    HrConfirmEn[HrConfirmEn["Rejected"] = 3] = "Rejected";
})(HrConfirmEn || (HrConfirmEn = {}));
